import React from "react";
import OrganizationFilterForm from "./OrganizationFilterForm";

const OrganizationFilter: React.FC = () => {
  return <OrganizationFilterForm />;
};

export default OrganizationFilter;
